import React from 'react';
import RiskScoreCell from 'src/shared/components/risk-score-cell/RiskScoreCell';
import FactorScoreBar from 'src/shared/components/factor-score-bar/FactorScoreBar';
import type { ScoreBand } from 'src/shared/components/risk-score-cell/riskScoreColour';

const BAND_LABELS: Record<ScoreBand, string> = {
    1: 'Very Poor',
    2: 'Poor',
    3: 'Moderate',
    4: 'Good',
    5: 'Very Good',
};

type ScoreBarProps = { score: number | null; band?: never };
type StepperProps = { band: ScoreBand; score?: never };

export type SonFactorProps = { name: string } & (ScoreBarProps | StepperProps);

const SonFactor = ({ name, score, band }: SonFactorProps) => {
    if (band !== undefined) {
        return (
            <div className='flex flex-col gap-1 py-2'>
                <div className='flex justify-between'>
                    <span className='text-sm font-normal text-foreground min-w-0 flex-1'>{name}</span>
                    <span className='text-sm font-normal text-foreground'>{BAND_LABELS[band]}</span>
                </div>
                <FactorScoreBar band={band} />
            </div>
        );
    }

    return (
        <div className='flex flex-col gap-1 py-2'>
            <div className='flex justify-between'>
                <span className='text-sm font-normal text-foreground min-w-0 flex-1'>{name}</span>
                <span className='text-sm font-normal text-foreground tabular-nums shrink-0'>{score !== null ? score.toFixed(2) : '—'}</span>
            </div>
            <RiskScoreCell value={score} direction='higher-better' layout='bar-only' />
        </div>
    );
};

export default SonFactor;
